import React, { useState } from "react";

import { EnterpriseGrid } from "@pollyslack/hub/src/types";

import { Code } from "../../../components/Code";
import { Date } from "../../../components/Date";
import { ExpanderContent, ExpanderToggle } from "../../../components/Expander";
import * as EnterpriseApi from "../../../services/api/Enterprise";
import { toast } from "react-toastify";

type EnterprioseDetailsProps = {
  enterprise: EnterpriseGrid;
  decryptedSlackBotToken?: string;
  onTokenDecrypt?: () => void;
};

export const EnterpriseDetails: React.FunctionComponent<
  EnterprioseDetailsProps
> = (props: EnterprioseDetailsProps) => {
  const enterprise = props.enterprise;
  const [expanded, setExpanded] = useState(false);
  const [marketingEnabled, setMarketingEnabled] = useState(
    enterprise?.settings?.optIns?.marketing !== false,
  );
  const [saving, setSaving] = useState(false);
  return (
    <div>
      <table className="table table-sm table-hover">
        <tbody>
          <tr>
            <th>ID</th>
            <td>{enterprise._id}</td>
          </tr>
          <tr>
            <th>Slack Enterprise ID</th>
            <td>{enterprise.slackEnterpriseId}</td>
          </tr>
          <tr>
            <th>Name</th>
            <td>{enterprise.slackEnterpriseName}</td>
          </tr>
          <tr>
            <th>Marketing Opt-In</th>
            <td>
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="egMarketingOptIn"
                  checked={marketingEnabled}
                  disabled={saving}
                  onChange={async () => {
                    try {
                      setSaving(true);
                      const next = !marketingEnabled;
                      await EnterpriseApi.setMarketingOptIn(
                        enterprise.slackEnterpriseId,
                        next,
                      );
                      enterprise.settings ??= {};
                      enterprise.settings.optIns ??= {};
                      enterprise.settings.optIns.marketing = next;
                      setMarketingEnabled(next);
                      toast.success("Enterprise marketing settings updated");
                    } catch (e: any) {
                      toast.error(e.message);
                    } finally {
                      setSaving(false);
                    }
                  }}
                />
                <label
                  className="custom-control-label"
                  htmlFor="egMarketingOptIn"
                >
                  {marketingEnabled ? "Opted In" : "Opted Out"}
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th>Created</th>
            <td>
              <Date date={enterprise.createdAt} />
            </td>
          </tr>
          <tr>
            <th>Bot ID</th>
            <td>{enterprise.slackBotUserId}</td>
          </tr>
          {(props.onTokenDecrypt !== null || props.decryptedSlackBotToken) && (
            <tr>
              <th>Bot Token</th>
              <td>
                {props.decryptedSlackBotToken ? (
                  <>{props.decryptedSlackBotToken}</>
                ) : (
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={props.onTokenDecrypt}
                  >
                    Decrypt Token
                  </button>
                )}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      View raw json{" "}
      <ExpanderToggle
        expanded={expanded}
        toggle={() => setExpanded(!expanded)}
      />
      <ExpanderContent expanded={expanded}>
        <Code object={props.enterprise} />
      </ExpanderContent>
    </div>
  );
};
